module.exports = __webpack_public_path__ + "static/CircularPro-Bold.ba909b53.ttf";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CircularPro-Bold.ttf
// module id = 639
// module chunks = 168707334958949